import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AdminService } from '../../../service/admin.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-index',
  imports: [
    MatCardModule,
    RouterLink
  ],
  templateUrl: './index.component.html',
  styleUrl: './index.component.less'
})
export class IndexComponent {
  adminService = inject(AdminService);
}
